import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchDestinations } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Destinations() {
    const [destinations, setDestinations] = useState([]);

    useEffect(() => {
        fetchDestinations().then(setDestinations).catch(() => {});
        document.title = "Destinations · MotorcycleRoutesIreland";
    }, []);

    return (
        <div data-testid="destinations-page">
            <section className="pt-40 pb-16 border-b border-[var(--border-hair)]">
                <div className="max-w-7xl mx-auto px-6 lg:px-10">
                    <div className="eyebrow fade-up">Where to Go</div>
                    <h1 className="mt-4 font-display font-black uppercase text-[var(--fg)] text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tighter fade-up fade-up-delay-1">
                        Six regions.<br />One island.
                    </h1>
                    <p className="mt-8 font-body text-[var(--fg-muted)] text-lg max-w-2xl fade-up fade-up-delay-2">
                        Pick a base, ride for a week. Each of these destinations is a self-contained touring paradise with enough road within an hour's ride to keep you busy.
                    </p>
                </div>
            </section>

            <section className="py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 gap-6">
                    {destinations.map((d, i) => (
                        <Link
                            key={d.slug}
                            to={`/destinations/${d.slug}`}
                            data-testid={`destination-card-${d.slug}`}
                            className="group relative aspect-[4/3] overflow-hidden border border-[var(--border-hair)] hover:border-[#E87722] transition-all fade-up"
                            style={{ animationDelay: `${i * 80}ms` }}
                        >
                            <img src={d.hero_image} alt={d.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
                            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                            <div className="relative h-full flex flex-col justify-end p-10">
                                <div className="text-xs font-body uppercase tracking-[0.28em] text-[#E87722] mb-3">{d.tagline}</div>
                                <h2 className="font-display font-black uppercase text-6xl md:text-7xl text-[var(--fg)] leading-none tracking-tighter">{d.name}</h2>
                                <p className="mt-4 font-body text-[var(--fg-muted)] text-base leading-relaxed max-w-lg">{d.description}</p>
                                <div className="mt-6 inline-flex items-center gap-2 font-display font-bold uppercase tracking-[0.2em] text-sm text-[var(--fg)] group-hover:text-[#E87722]">
                                    Explore <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
